import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { Button } from '#/modules/commonComponents/button';
import {
  WORK_ORDER_STOCK_OPS_PAGE_CONFIG,
  getWorkOrderStockOpsFormNavItems,
  getWorkOrderStockOpsListNavItems,
} from '#/modules/momMgmt/workOrder/helper/workOrderStockOpsNavConfig';

const WorkOrderStockOpsPageHeader = ({
  page,
  variant,
  statusSlot = null,
  trailing = null,
}) => {
  const { title } = WORK_ORDER_STOCK_OPS_PAGE_CONFIG[page];

  if (variant === 'list') {
    const navItems = getWorkOrderStockOpsListNavItems(page);

    return (
      <h1 className="page_title flex flex-wrap items-center gap-2">
        <span className="border-l-5 border-primary-400 pl-2.5">{title}</span>
        {navItems.map((item) => (
          <Button key={item.label} type="button" asChild>
            <Link to={item.to}>{item.label}</Link>
          </Button>
        ))}
        {statusSlot}
        {trailing}
      </h1>
    );
  }

  const navItems = getWorkOrderStockOpsFormNavItems(page);

  return (
    <div className="create_edit_page__header">
      <h1 className="page_title mb-0!">
        <span className="border-l-5 border-primary-400 pl-2.5">{title}</span>
      </h1>
      <div className="flex flex-wrap items-center gap-2">
        {navItems.map((item) => (
          <Button
            key={item.label}
            type="button"
            variant={item.variant ?? 'outline'}
            asChild
          >
            <Link to={item.to}>{item.label}</Link>
          </Button>
        ))}
        {statusSlot}
        {trailing}
      </div>
    </div>
  );
};

WorkOrderStockOpsPageHeader.propTypes = {
  page: PropTypes.oneOf(['workOrder', 'transfer', 'return']).isRequired,
  variant: PropTypes.oneOf(['list', 'form']).isRequired,
  statusSlot: PropTypes.node,
  trailing: PropTypes.node,
};

export default WorkOrderStockOpsPageHeader;
